module.exports = __webpack_public_path__ + "static/media/workspace_demo.e48e14e7.png";